import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "../components/pages/Home";
import Tool from "../components/pages/Tool";
import HowTo from "../components/pages/HowTo";
import Policy from "../components/pages/Policy";
import Terms from "../components/pages/Terms";  // 利用規約を追加
import Layout from "../components/templates/Layout";

const AppRouter = () => {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/tool" element={<Tool />} />
          <Route path="/howto" element={<HowTo />} />
          <Route path="/policy" element={<Policy />} />
          <Route path="/terms" element={<Terms />} />  {/* 利用規約ページ */}
        </Routes>
      </Layout>
    </Router>
  );
};

export default AppRouter;
